export * from '@web/utils/@axios/requests';

export const portalApiGWBaseURL = `${process.env.NX_API_GATEWAY}`;
